import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { SubTitle, FormItem, FormText, Div, SapId, Row } from 'ui';
import { injectIntl } from 'react-intl';

const General = ({ data, parentInfo, intl }) => {
  const { number, notificationType, startDate, visitType } = data;
  const mainWorkCenterName = parentInfo?.mainWorkCenterName;

  return (
    <>
      <SubTitle>{intl.formatMessage({ id: 'common.titles.GENERAL' })}</SubTitle>
      <Div marginBottom={20}>
        <Row type='flex' gutter={16} marginRight={0}>
          <Col md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'notification.NOTIFICATION_SAP' })}>
              {/* use the ID component to tansform to 'readable' ID (without leading zeroes) */}
              <SapId originalId={number}>{id => <FormText>{id}</FormText>}</SapId>
            </FormItem>
          </Col>
          <Col md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'notification.TYPE' })}>
              <FormText>{notificationType}</FormText>
            </FormItem>
          </Col>
          <Col md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'notification.VISIT_TYPE' })}>
              <FormText>{visitType}</FormText>
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16} marginRight={0}>
          <Col md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'notification.REQUIRED_START_DATE' })}>
              <FormText>{startDate && intl.formatDate(startDate)}</FormText>
            </FormItem>
          </Col>
          <Col md={16} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'notification.PREFERRED_TECHNICIAN' })}>
              <FormText>{mainWorkCenterName}</FormText>
            </FormItem>
          </Col>
        </Row>
      </Div>
    </>
  );
};

General.propTypes = {
  parentInfo: PropTypes.object,
  data: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(General);
